import Vue from 'vue'
import {
  ImageMessage,
  TextMessage,
} from '@/components/chat'

import Contextmenu from 'vue-contextmenujs'
Vue.use(Contextmenu)

Vue.component(ImageMessage.name, ImageMessage)
Vue.component(TextMessage.name, TextMessage)

